

















import {
    defineComponent,
    reactive,
    toRefs,
    computed,
} from '@vue/composition-api';
import { useApolloModel } from 'vue-apollo-model';
import Vue from 'vue';

export default defineComponent({
    props: {
        width: {
            type: Number,
            default: 360,
        },
        height: {
            type: Number,
        },
        isShow: {
            type: Boolean,
            default: false,
        },
    },
    model: {
        prop: 'isShow',
        event: 'update',
    },
    setup(props, context) {
        function toggle() {
            context.emit('update', !props.isShow);
        }
        return {
            toggle,
        };
    },
});
